const PENDING_REFERRAL_KEY = "lms_pending_referral";
/** A referral stays with the visitor for 30 days, like a typical affiliate cookie. */
const REFERRAL_TTL_MS = 30 * 24 * 60 * 60 * 1000;

/**
 * PAY-9: a `?ref=` code seen on a course page is remembered per tenant, so it survives
 * signing in or creating an account (which may happen in another tab — hence localStorage,
 * like the pending invite) and is still sent with the checkout afterwards.
 */
export function rememberReferral(tenantSlug: string, code: string, now: number = Date.now()) {
  const trimmed = code.trim().slice(0, 64);
  if (!trimmed) return;
  try {
    localStorage.setItem(
      PENDING_REFERRAL_KEY,
      JSON.stringify({ tenantSlug, code: trimmed, at: now }),
    );
  } catch {
    // Storage blocked: the ref link still works when opened again after signing in.
  }
}

/** The remembered code for this tenant, if it has not expired. */
export function readPendingReferral(tenantSlug: string, now: number = Date.now()): string | null {
  try {
    const raw = localStorage.getItem(PENDING_REFERRAL_KEY);
    if (!raw) return null;
    const pending = JSON.parse(raw) as { tenantSlug?: string; code?: string; at?: number };
    if (pending.tenantSlug !== tenantSlug || !pending.code) return null;
    if (typeof pending.at !== "number" || now - pending.at > REFERRAL_TTL_MS) {
      localStorage.removeItem(PENDING_REFERRAL_KEY);
      return null;
    }
    return pending.code;
  } catch {
    return null;
  }
}

/** Once a checkout has carried the code, it has done its job. */
export function clearPendingReferral() {
  try {
    localStorage.removeItem(PENDING_REFERRAL_KEY);
  } catch {
    // ignore
  }
}
